module.exports = __webpack_public_path__ + "static/img/target-oxbridge-double-black-students.ddd233f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/target-oxbridge-double-black-students.png
// module id = q9Wm
// module chunks = 0